/*
* Copyright (C) Regione Lombardia
*/
import { Component, EventEmitter, Output } from '@angular/core';
import { OperaService } from '@shared/services/opera.service';
import { PermessiService } from '@shared/services/permessi.service';
import { ViewerService } from '@shared/services/viewer.service';

@Component({
    selector: 'app-toolkit-opera-tab-cartografia',
    templateUrl: './tab-cartografia.component.html',
})
export class ToolkitGestioneOperaTabCartografiaComponent {
    
    @Output() viewerOpened: EventEmitter<any> = new EventEmitter();


    constructor(
        public operaService: OperaService,
        public permessiService: PermessiService,
        private viewerService: ViewerService,

    ) { }

    public goToViewerOpera() {
        this.viewerService.getUrlViewerOpera(this.operaService.operaSession.idOpera, this.operaService.operaSession.codIstat, this.operaService.operaSession.idTipologiaOpera).subscribe((response: any) => {
            const win: Window | null =  window.open(response.urlViewer, 'blank');
            this.viewerOpened.emit(win);
        }
        );
    }


}
